import { lazy } from "react";

export { default as Loading } from "components/KYC2/graphics/Loading";
export const CreditCard = lazy(() => import("./CreditCard"));
export const Deposit = lazy(() => import("./Deposit"));
export const Wallet = lazy(() => import("./Wallet"));
export const Paypal = lazy(() => import("./Paypal"));
export const Bank = lazy(() => import("./Bank"));
export const TokenPurchase = lazy(() => import("./TokenPurchase"));
export const TokenConvert = lazy(() => import("./TokenConvert"));
export const Refund = lazy(() => import("./Refund"));
